/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateReservationRequest } from '../model'
// @ts-ignore
import type { CreateReservationResponse } from '../model'
// @ts-ignore
import type { DeleteReservationRequest } from '../model'
/**
 * ReservationsApi - axios parameter creator
 */
export const ReservationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {DeleteReservationRequest} [deleteReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteReservation: async (
      deleteReservationRequest?: DeleteReservationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Reservations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteReservationRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateReservationRequest} [createReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putReservation: async (
      createReservationRequest?: CreateReservationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Reservations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createReservationRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ReservationsApi - functional programming interface
 */
export const ReservationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReservationsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {DeleteReservationRequest} [deleteReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteReservation(
      deleteReservationRequest?: DeleteReservationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReservation(
        deleteReservationRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReservationsApi.deleteReservation']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateReservationRequest} [createReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putReservation(
      createReservationRequest?: CreateReservationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateReservationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.putReservation(
        createReservationRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReservationsApi.putReservation']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ReservationsApi - factory interface
 */
export const ReservationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ReservationsApiFp(configuration)
  return {
    /**
     *
     * @param {DeleteReservationRequest} [deleteReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteReservation(
      deleteReservationRequest?: DeleteReservationRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteReservation(deleteReservationRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateReservationRequest} [createReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putReservation(
      createReservationRequest?: CreateReservationRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateReservationResponse> {
      return localVarFp
        .putReservation(createReservationRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * ReservationsApi - object-oriented interface
 */
export class ReservationsApi extends BaseAPI {
  /**
   *
   * @param {DeleteReservationRequest} [deleteReservationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteReservation(
    deleteReservationRequest?: DeleteReservationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReservationsApiFp(this.configuration)
      .deleteReservation(deleteReservationRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateReservationRequest} [createReservationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public putReservation(
    createReservationRequest?: CreateReservationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReservationsApiFp(this.configuration)
      .putReservation(createReservationRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
